import { useAppSelector } from "~/src/system/store/hooks";

export const useActiveUser = () => {
  const userData = useAppSelector((state) => state.userData.profiles);
  const userId = userData.flowUser.user.id;

  return { user: userData, userId, isLoaded: !!userId };
};
